import { xs_languageCode } from "..";
import { getUrlPathSeoSettings } from "./utils/getUrlPathSeoSettings";
import { getUrlPathSeo } from "./utils/getUrlPathSeo";
import { isCotaOrExtra } from "./utils/isCotaOrExtra";
import { parseAdditionalData } from "./parseAdditionalData";
import { parseBetsData } from "./parseBetsData";
import parseJerseys from "./parseJerseys";
import { parseMacroGruppi } from "./parseMacroGruppi";
import { getUrlPath } from "./util/getUrlPath";
import { byRanking } from './utils/byRanking';
import { compare2Dates } from './utils/compare2Dates';
import { filterByCustomizedState } from './utils/filterByCustomizedState';
import { formatDate } from './utils/formatDate';
import { formatDateWithWeekDay } from './utils/formatDateWithWeekDay';
import { getConfiguration } from './utils/configuration';
import { getDateAndTime } from './utils/getDateAndTime';
import { getDateFromTimestamp } from './utils/getDateFromTimestamp';
import { getLocaleTimestamp } from './utils/getLocaleTimestamp';
import { getPalAvvFromDesc } from './utils/getPalAvvFromDesc';
import { getPrematchAggs } from './utils/getPrematchAggs';
import { getRanking } from './utils/getRanking';
import { getSplitDesc } from './utils/getSplitDesc';
import { getTimestampConformedUTC } from './utils/getTimestampConformedUTC';
import { iconCategoryCssClass } from './utils/iconCategoryCssClass';
import { nHoursFromNow } from './utils/nHoursFromNow';

function sortByTimestamps(time1, time2) {
	const comparedResult = compare2Dates(getDateFromTimestamp(time1), getDateFromTimestamp(time2));
	return comparedResult;
}

let getTime = function(timestamp) {
    const conf = getConfiguration();
    if (conf.dbutc)     {
        getTime = function(timestamp) {
            return getLocaleTimestamp(timestamp).split(' ')[1];
        };
    } else {
        getTime = function(timestamp) {
            return timestamp.split(' ')[1];
        };
    }
    return getTime(timestamp);
}

function getRankingOrDefault(ranking) {
    if (ranking) {
        const systemCode = getConfiguration().sys;
        return ranking[systemCode] || ranking['DEFAULT'];
    }
    return 0;
}

export function parseTournamentsByDate(data, date, sportId, aggregata, hoursLimit) {
    const categoryRankingById = data.cks;
    const tournamentDescById = data.dts;
    const tournamentIcoById = data.icts || {};
    const tournamentRankingById = data.rks;
    const conf = getConfiguration();
    const sportById = new Map();
    const sport = filterByCustomizedState(data.sps).map(s => {
        const sport = {
            aggregata: s.ag,
            descrizione: s.dsl[xs_languageCode],
            eventsCount: 0,
            tournamentsCount: Object.keys(s.tns).length,
            iconClass: s.ic,
            id: s.id,
            isLive: s.lv,
            macrogruppo: s.mc,
            ranking: getRanking(s),
            showInBetBuilderSection : s.abb !== undefined? s.abb : true

        };
        sportById.set(s.id, sport);
        return sport;
    }).sort(byRanking);
    
    let events = filterByCustomizedState(data.avs.avs);
    const current = getDateAndTime();
    if (hoursLimit != null) { // Process only the matches referring to future dates/times within the limit
        const maxTime = nHoursFromNow(hoursLimit).split(' ')[1];
        events = events.filter(e => {
            const time = getTime(e.ts);
            if (date !== current.date || time <= current.time || time > maxTime) {
                return false;
            }
            return true;
        })
    } else if (date === current.date) { // Process only the matches referring to future dates/times
        events = events.filter(e => {
            //const time = getTime(e.ts);
            //return time > current.time;
            const dateEvent = getDateFromTimestamp(getTimestampConformedUTC(e.ts));
            return compare2Dates(dateEvent, current.dateObject) === 1; 
        });
    }

    let aggs = data.avs.ags;
    if (!window.isCotaExtraEnabled) {
        aggs = aggs.filter(aggId => !isCotaOrExtra(false, sportId, aggId));
    }
    
    const tournamentsSet = new Set();
    const matches = [];
    const times = [];
    const matchesByTime = new Map();
    if (events.length > 0) {
        const sport = sportById.get(sportId);
        sport.tournamentsCount = 0;
        
        // Add matches to tournament
        events.forEach((m, i) => {
            const matchDesc = m.dsl[xs_languageCode];
            const [desc, avvRef] = getPalAvvFromDesc(matchDesc);
            const tournamentDesc = tournamentDescById[`${xs_languageCode}_${m.it}`];
            const [team1, team2] = getSplitDesc(desc);
            const uniqueId = `${sportId}_${m.ic}_${m.it}_${m.bid}`;
            const sportDesc = sport.descrizione;
            const hasBetBuilder = m.abb && conf.bbc.en;
            const matchData = {
                alias: m.al,
                avv: m.a,
                desc,
                id: m.bid,
                pal: m.p,
                seoSettings: m.seo,
                seoSettingsAdds: m.seoa,
                sportDesc,
                sportRef: sportId,
                timestamp: m.ts,
                tournamentDesc,
                tournamentRef : m.it,
                uniqueId,
                urlPath: getUrlPath({uniqueId: `${sportId}_${m.ic}_${m.it}`, urlPath: `${sportDesc}/${tournamentDesc}`}, m, desc),
                urlPathSeo: getUrlPathSeo({...m,seoSettings:m.seo}),
                urlPathSeoSettings: getUrlPathSeoSettings({...m,seoSettingsAdds:m.seoa}),
                plusByAggregateId : m.plba,
                hasBetBuilder
            };

            const formattedDate = formatDateWithWeekDay(m.ts);
            const dateShort = formattedDate.dayMonthShort;
            const dateShortYear = formattedDate.dayMonthYearShort;
            const dateString = formattedDate.dayMonthYear;

            const betsData = parseBetsData(matchData, aggs, aggregata, m.scs, false, true);
            const match = {
                additionalData: parseAdditionalData(m.add),
                alias: m.al,
                avv: m.a,
                avvRef,
                categoryRef: m.ic,
                date: dateString,
                dateShort,
                dateShortYear,
                desc,
                favorite: false,
                icoTournament : tournamentIcoById[m.it],
                id: m.bid,
                isLive: m.lv,
                jerseys: parseJerseys(m.j, sportId),
                info: m.v,
                openAggregata: m.oa,
                openMacrogruppo: m.om,
                pal: m.p,
                plus: m.pl,
                plusByAggregateId : m.plba,
                sportDesc,
                sportRef: sportId,
                widgetType: m.wty,
                geniusId: m.gid,
                lsportWidgetId: m.lswid,
                team1,
                team2,
                time: formatDate(m.ts).time,
                timestampDB: m.ts,
                tournamentDesc,
                tournamentRef: m.it,
                uniqueId,
                urlPath: getUrlPath({uniqueId: `${sportId}_${m.ic}_${m.it}`, urlPath: `${sportDesc}/${tournamentDesc}`}, m, desc),
                urlPathSeo: getUrlPathSeo(matchData),
                urlPathSeoSettings: getUrlPathSeoSettings(matchData),
                str: m.str,
                hasBetBuilder
            };
            Object.assign(match, betsData);
            // If after the timezone conversion the match time is earlier than previous matches,
            // place the match in the correct position
            if (matches[i - 1]?.time > match.time) {
                const index = matches.findIndex(m => m.time > match.time);
                matches.splice(index, 0, match);
            } else {
                matches.push(match);
            }
            sport.eventsCount++;
            if  (!tournamentsSet.has(match.tournamentRef)) {
                tournamentsSet.add(match.tournamentRef);
                sport.tournamentsCount++;
            }
    
            // Group matches by time
            //const time = getTime(m.ts);
            const time = m.ts; // NB: da quando skywind ha voluto che nel giorno selezionato fossero compresi anche gli eventi del giorno successivo entro le 6, va considerato l'intero timestamp
            if (!matchesByTime.has(time)) {
                matchesByTime.set(time, []);
                times.push(time);
            }
            matchesByTime.get(time).push(match);
        });
    }
	times.sort(sortByTimestamps);
    // For any given time, group matches by competition
    const tournamentsByTime = new Map();
    times.forEach(time => {
        const tournaments = [];
        const tournamentById = new Map();
        const matches = matchesByTime.get(time);
        matches.forEach(match => {
            const tournamentId = match.tournamentRef;
            if (!tournamentById.has(tournamentId)) {
                const categoryIcon = iconCategoryCssClass(match.sportRef, match.categoryRef, tournamentIcoById[tournamentId]);
                const tournament = {
                    categoryIcon,
                    categoryRanking: getRankingOrDefault(categoryRankingById?.[match.categoryRef]),
                    categoryRef: match.categoryRef,
                    desc: tournamentDescById[`${xs_languageCode}_${tournamentId}`],
                    id: tournamentId,
                    matches: [match],
                    ranking: getRankingOrDefault(tournamentRankingById?.[match.tournamentRef]),
                    sportRef: match.sportRef,
                    uniqueId: `${match.sportRef}_${match.categoryRef}_${tournamentId}`
                };
                tournaments.push(tournament);
                tournamentById.set(tournamentId, tournament);
            } else {
                tournamentById.get(tournamentId).matches.push(match);
            }
        });
        tournamentsByTime.set(time, tournaments);
    });

    const tournaments = [];
    const tournamentById = new Map();
    matches.forEach(m => {
        const tournamentId = m.tournamentRef;
        if (tournamentById.has(tournamentId)) {
            tournamentById.get(tournamentId).matches.push(m);
        } else {
            const categoryIcon = iconCategoryCssClass(m.sportRef, m.categoryRef, tournamentIcoById[tournamentId]);
            const events = [m];
            const tournament = {
                additionalData: parseAdditionalData(data.addt?.[tournamentId]),
                categoryIcon,
                categoryRanking: getRankingOrDefault(categoryRankingById?.[m.categoryRef]),
                categoryRef: m.categoryRef,
                desc: tournamentDescById[`${xs_languageCode}_${tournamentId}`],
                id: tournamentId,
                events,
                matches: events,
                ranking: getRankingOrDefault(tournamentRankingById?.[m.tournamentRef]),
                sportRef: m.sportRef,
                uniqueId: `${m.sportRef}_${m.categoryRef}_${tournamentId}`
            };
            tournaments.push(tournament);
            tournamentById.set(tournamentId, tournament);
        }
    });
    
    // ordino gli eventi del torneo per timestamp
	tournaments.forEach(t => {
		t.events?.sort((a,b) => {
			return sortByTimestamps(a.timestampDB, b.timestampDB);
		}); 
		t.matches?.sort((a,b) => {
			return sortByTimestamps(a.timestampDB, b.timestampDB);
		});
	})
    // Sort tournaments by category ranking and tournament ranking
    tournaments.sort((a, b) => {
        if (a.categoryRanking === b.categoryRanking) {
            return a.ranking - b.ranking;
        } else {
            return a.categoryRanking - b.categoryRanking;
        }
    });
    
    // Sort matches by category ranking, tournament ranking and timestamp
    matches.sort((a, b) => {
        const tournamentA = tournamentById.get(a.tournamentRef);
        const tournamentB = tournamentById.get(b.tournamentRef);

        if (tournamentA.categoryRanking === tournamentB.categoryRanking) {
            if (tournamentA.ranking === tournamentB.ranking) {
                //return a.timestampDB.localeCompare(b.timestampDB);
                return compare2Dates(getDateFromTimestamp(b.timestampDB), getDateFromTimestamp(a.timestampDB));
            } else {
                return tournamentA.ranking - tournamentB.ranking;
            }
        } else {
            return tournamentA.categoryRanking - tournamentB.categoryRanking;
        }
    });

    const aggregateMap = {};
    aggs.forEach(ag => {
        const aggData = getPrematchAggs(sportId, ag);
        if (aggData != null) {
            aggregateMap[ag] = aggData; 
        }
    });
    const macrogruppi = parseMacroGruppi(aggregateMap, sportId, false);

    return {
        macrogruppi,
        events: matches,
        matches,
        sport,
        sportById,
        times,
        tournamentById,
        tournaments,
        tournamentsByTime
    };
}
